export const STATUS_COLOR = {
	error: 'error.main',
	success: 'success.main',
	secondary: 'secondary.light',
	primary: 'primary.main',
}
